import { SupabaseDownloadSignatureRequestAuditLogRepository } from '@/shared/infra/repositories'
import type { DownloadSignatureRequestAuditLog } from '@/shared/domain'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeDownloadSignatureRequestAuditLog(): DownloadSignatureRequestAuditLog {
  return new SupabaseDownloadSignatureRequestAuditLogRepository(
    makeSupabaseEdgeHttpClient(),
  ).execute
}
